// NoProjectsPage — authenticated user with zero project memberships.
//
// Reached via resolveLanding case (6). A terminal dead-end rendered inside
// SlimAuthedLayout (brand=lockup, account=minimal — RubixEMS lockup + trimmed
// avatar); the body is just the explanation + "contact your administrator" CTA.
// No way forward in-app by design — only an administrator can grant project
// membership (ADR-018 platform-routes + ADR-016 URL trust zones).

import { useTranslation } from 'react-i18next';
import { Alert } from '../components/ui/Alert.js';
import { useDocumentTitle } from '../hooks/useDocumentTitle.js';

export function NoProjectsPage() {
  const { t } = useTranslation('common');
  useDocumentTitle(t('noProjects.title'));

  return (
    <div className="flex-1 flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="space-y-4">
          <h1 className="text-xl font-bold text-[var(--color-text-primary)] text-center">
            {t('noProjects.title')}
          </h1>
          <Alert variant="info">{t('noProjects.body')}</Alert>
          <p className="text-sm text-[var(--color-text-secondary)] text-center">
            {t('noProjects.cta')}
          </p>
        </div>
      </div>
    </div>
  );
}

export default NoProjectsPage;
